import FeatureGates from '@atlaskit/feature-gate-js-client';
import type { HelpObjectStoreArticleSourceSystem } from '../../help-center/search/src/articles/__generated__/articlesSearchQuery.graphql';
import { addParamsToUrl } from '../history-qs';
import type { ArticleSource } from './types';

// Used for Analytics Call.
export const addSourceToUrl = (
	url: string,
	source: ArticleSource,
	shouldReturnUrlWithoutSource: boolean = false,
): string => {
	if (shouldReturnUrlWithoutSource || !FeatureGates.checkGate('jsm_kb_source_value_in_query_param'))
		return url;
	return addParamsToUrl(url, { source });
};

export const is3pOrExternalSource = (
	sourceSystem: HelpObjectStoreArticleSourceSystem | null | undefined,
): boolean => {
	return (
		sourceSystem === 'EXTERNAL' || sourceSystem === 'SHAREPOINT' || sourceSystem === 'GOOGLE_DRIVE'
	);
};
